/* eslint-disable max-len */
/* eslint no-nested-ternary: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { withTranslation } from 'react-i18next';
import {
  Feed,
  Grid,
  List,
} from 'semantic-ui-react';
import moment from 'moment-timezone';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';
import Timestamp from './Timestamp';

// Still needed for the module-level locale; the feed date renders through Timestamp.
moment.locale('en-gb');

class ExportActivities extends Component {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    hasAccess: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    showAll: PropTypes.bool,
    t: PropTypes.func,
  }
  renderActivityTitle = (exportType, fileName) => {
    const { t } = this.props;
    const exportedLabel = t('Exported', { ns: TRANSLATION_FILES.translation, defaultValue: 'Exported' });

    return `${exportedLabel}: ${exportType} (${fileName})`;
  }
  render() {
    const { data, t } = this.props;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <Feed>
              { data && data.length > 0 ?
              data.map((activity, idx) => (
                <Feed.Event key={idx} className="activity-logs">
                  <Feed.Label icon="user" />
                  <Feed.Content>
                    <Feed.Date>
                      <Timestamp timestamp={activity.createdAt} format="MMMM Do YYYY, h:mm:ss a" />
                    </Feed.Date>
                    <Feed.Summary>
                      {this.props.hasAccess ?
                        activity.userAffiliateID > 0 ?
                          <Link to={`/users/${activity.userAffiliateID}/`}>
                            {activity.userPreferredName || t('Unknown')}
                          </Link>
                           : ''
                         : activity.userPreferredName
                      }
                      {` ${this.renderActivityTitle(activity.exportType, activity.fileName)}`}
                    </Feed.Summary>
                    {this.props.showAll ?
                      <Feed.Extra text>
                        <List bulleted>
                          <List.Item>
                            <span><span style={{ color: '#666' }}>{t('File Name:', { ns: TRANSLATION_FILES.translation })}</span> <u>{activity.fileName}</u></span>
                          </List.Item>
                          <List.Item>
                            <span><span style={{ color: '#666' }}>{t('File Download Link:', { ns: TRANSLATION_FILES.translation })}</span> <u>{activity.fileLink}</u></span>
                          </List.Item>
                        </List>
                      </Feed.Extra>
                      : ''
                    }
                  </Feed.Content>
                </Feed.Event>
              )) :
                this.props.loading ?
                  <br />
                : <center>{t('No activity found')}.</center>
              }
            </Feed>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withTranslation([...namespaces])(connect(ExportActivities.mapStateToProps)(ExportActivities));



// WEBPACK FOOTER //
// ./src/components/ExportActivities.jsx